import { FabProps } from '@mui/material/Fab';
import { mdiMenuDown } from '@mdi/js';

import { DropdownMenu } from 'common/components/DropdownMenu';
import { Icon } from 'common/components/Icon';
import {
    ActionButton,
    ActionButtonGroup,
} from 'common/components/ActionButton';

interface IProps extends React.ComponentProps<typeof ActionButtonGroup> {
    children: React.ReactNode;
    menuItems?: React.ReactNode;
    disabled?: boolean;
    size?: FabProps['size'];
    buttonProps?: React.ComponentProps<typeof ActionButton>;
    enablePortal?: boolean;
}

export const ActionButtonDropdown = ({
    children,
    menuItems,
    onClick,
    disabled,
    size,
    buttonProps,
    enablePortal,
    ...other
}: IProps) => (
    <ActionButtonGroup {...other}>
        <ActionButton
            outlined
            disabled={disabled}
            size={size}
            variant="extended"
            onClick={onClick}
            {...buttonProps}
        >
            {children}
        </ActionButton>
        {menuItems && (
            <DropdownMenu
                anchor={
                    <ActionButton outlined disabled={disabled} size={size}>
                        <Icon
                            path={mdiMenuDown}
                            size={size === 'small' ? '2.8rem' : '3rem'}
                        />
                    </ActionButton>
                }
                enablePortal={enablePortal}
                placement="bottom-end"
            >
                {menuItems}
            </DropdownMenu>
        )}
    </ActionButtonGroup>
);
